var neutralSubtle = {
  variant: 'neutral-subtle'
};
var neutral = {
  variant: 'neutral'
};
var neutralModerate = {
  variant: 'neutral-moderate'
};
var base = {
  variant: 'base'
};
var baseInverse = {
  variant: 'base'
};
var roundedSubtle = {
  variant: 'rounded-subtle'
};
var roundedBold = {
  variant: 'rounded-bold'
};
var roundedStrong = {
  variant: 'rounded-strong'
};
var dividerVariants = {
  neutralSubtle: neutralSubtle,
  neutral: neutral,
  neutralModerate: neutralModerate,
  base: base,
  baseInverse: baseInverse,
  roundedBold: roundedBold,
  roundedSubtle: roundedSubtle,
  roundedStrong: roundedStrong
};

export { dividerVariants };
//# sourceMappingURL=divider.variants.esm.js.map
